var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:{ 'has-tabbar': _vm.showTabBar },attrs:{"id":"app"}},[_c('router-view'),(_vm.showTabBar)?_c('CommonTabbar'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }